import React from 'react';
import LegalLayout from '../components/layout/LegalLayout';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertCircle, FiActivity, FiBookOpen, FiHelpCircle } = FiIcons;

const navLinks = [
  { label: 'Summary', href: '#summary' },
  { label: 'Medical', href: '#medical' },
  { label: 'Urgent care', href: '#emergency' },
  { label: 'Religious', href: '#religious' },
  { label: 'Accuracy', href: '#accuracy' },
  { label: 'Contact', href: '#contact' },
];

const Disclaimer = () => {
  return (
    <LegalLayout title="Medical & Religious Disclaimer" lastUpdated="19 June 2026" navLinks={navLinks}>
      <p className="text-xl text-muted font-light mb-12">
        Nisaa is a tracking and educational tool. It is not intended to replace professional advice from clinicians or scholars.
      </p>

      <section id="summary">
        <div className="w-10 h-10 rounded-xl bg-paper border border-line flex items-center justify-center text-rose mb-4">
          <SafeIcon icon={FiBookOpen} className="w-5 h-5" />
        </div>
        <h2>1. Summary</h2>
        <p>Nisaa is designed to help users record information and understand general wellness and worship patterns. It is not a substitute for professional medical advice, emergency care, or qualified Islamic scholarship.</p>
      </section>

      <section id="medical">
        <div className="w-10 h-10 rounded-xl bg-paper border border-line flex items-center justify-center text-rose mb-4">
          <SafeIcon icon={FiActivity} className="w-5 h-5" />
        </div>
        <h2>2. Medical Disclaimer</h2>
        <div className="my-8 p-6 border-l-4 border-rose bg-rose/5 rounded-r-3xl">
          <p className="m-0 font-bold text-aubergine text-lg">Nisaa is not a medical device.</p>
          <p className="m-0 text-muted mt-2">It does not provide diagnosis, treatment, contraception advice, fertility guarantees, or emergency care.</p>
        </div>
        <p>Cycle predictions, fertile window estimates, and pregnancy dates are estimates based on user-entered records. They may be incomplete or inaccurate. Always consult a healthcare professional for medical decisions.</p>
      </section>

      <section id="emergency">
        <div className="w-10 h-10 rounded-xl bg-paper border border-line flex items-center justify-center text-rose mb-4">
          <SafeIcon icon={FiAlertCircle} className="w-5 h-5" />
        </div>
        <h2>3. Urgent Care</h2>
        <p><strong>Do not use Nisaa for emergencies.</strong> If you think you may be experiencing a medical emergency, seek urgent help immediately through local emergency services.</p>
        <p>If you are pregnant and experience reduced fetal movement, severe pain, or heavy bleeding, contact your maternity unit or emergency services promptly.</p>
      </section>

      <section id="religious">
        <div className="w-10 h-10 rounded-xl bg-paper border border-line flex items-center justify-center text-rose mb-4">
          <SafeIcon icon={FiBookOpen} className="w-5 h-5" />
        </div>
        <h2>4. Religious Disclaimer</h2>
        <p>Islamic guidance, prayer status, and fasting notes in Nisaa are intended for general educational support. They may not reflect your specific madhab, local practice, or personal medical circumstances.</p>
        <p>For binding religious rulings, consult a qualified Islamic scholar familiar with your specific context.</p>
      </section>

      <section id="contact">
        <div className="w-10 h-10 rounded-xl bg-paper border border-line flex items-center justify-center text-rose mb-4">
          <SafeIcon icon={FiHelpCircle} className="w-5 h-5" />
        </div>
        <h2>5. Contact & Support</h2>
        <p>If you have questions regarding these disclaimers, please contact Sussex Endocrine Clinic at <a href="mailto:contact@sussexendocrineclinic.co.uk">contact@sussexendocrineclinic.co.uk</a>.</p>
      </section>
    </LegalLayout>
  );
};

export default Disclaimer;